module.exports = __webpack_public_path__ + "static/img/frame.c31a116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/no/frame.png
// module id = 1417
// module chunks = 1